"use client"

import { useEffect } from "react"

import { babackSliceSchema } from "~/components/slices/Baback/_data/schema"
import { WithSafeSliceData } from "~/components/slices/WithSafeSliceData"

function Baback({}) {
  useEffect(() => {
    setTimeout(() => {
      window.baback.open("")
    }, 1000)
  }, [])

  return null
}

export default WithSafeSliceData(
  async function () {
    return <Baback />
  },
  babackSliceSchema,
  "BabackSlice"
)
